import { Game, Params, StringIndex } from "../../interfaces/interfaces";
import DefaultFields from "../DefaultFields/DefaultFields";

type Props = {
  setUrlForBranch: (url: string) => void;
  urlForBranch: string;
  isBranchTest: boolean;
  setBranchTest: (isBranchTest: boolean) => void;
  isProviderTest: boolean;
  setProviderTest: (isProviderTest: boolean) => void;
  params: Params;
  setParams: (params: Params) => void;
  slotGamesSorted: Game[];
  videoBingoGamesSorted: Game[];
  providerInputData: StringIndex;
  setProviderInputData: (providerInputData: StringIndex) => void;
  operatorUrl: string;
  setOperatorUrl: (operatorUrl: string) => void;
  ishomeURLValid: boolean;
  iscashierURLValid: boolean;
  setIshomeURLValid: (ishomeURLValid: boolean) => void;
  setIscashierURLValid: (iscashierURLValid: boolean) => void;
};

function FormLauncher({
  urlForBranch,
  setUrlForBranch,
  isBranchTest,
  setBranchTest,
  params,
  setParams,
  slotGamesSorted,
  videoBingoGamesSorted,
}: Props) {

  return (
    <>
      <DefaultFields
        urlForBranch={urlForBranch}
        setUrlForBranch={setUrlForBranch}
        isBranchTest={isBranchTest}
        setBranchTest={setBranchTest}
        params={params}
        setParams={setParams}
        slotGamesSorted={slotGamesSorted}
        videoBingoGamesSorted={videoBingoGamesSorted}
      />
    </>
  );
}

export default FormLauncher;
